import React, { useState } from "react";
import { useStyles } from "./PasswordStyle";
import { loginAction } from "../../store/actions/AuthAction";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

export default function Password() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
 

  const { username } = useSelector((state) => state.AuthReducer.userName);
  const data = {
    username,
    password,
  };

  const handleOnSubmit = () => {
    if (password === "") {
      toast.error("Enter Password")
    } else {
      dispatch(loginAction(setLoading, data));
    }
  };

  const styles = useStyles();
  return (
    <div className={styles.MainPage}>
      <div className={styles.PasswordContainer}>
        <div className={styles.PasswordHeading}>
          <h1 className={styles.text}>LOGO HERE</h1>
        </div>


        <div className={styles.HeaderContainer}>
          <p className={styles.HeaderdHeading}>Provide Password</p>
          <p className={styles.InputFieldHeading}>Password</p>

          <div className={styles.IconAndInputField}>
            <input
              onChange={(e) => setPassword(e.target.value)}
              className={styles.Input}
              type="password"
              placeholder="Enter Your Password"
            />
          </div>
          <div className={styles.ButtonContainer}>
            {loading?
            <button className={styles.PasswordButton}>
            <div className="ButtonLoader"/>
            </button>
            :
            <button className={styles.PasswordButton} onClick={handleOnSubmit}>
            Sign in
          </button>
}
          </div>

          <div className={styles.NewUserContainer}>
            <p className={styles.NewUserText}>New User?</p>
            <p className={styles.ForgotText}>Forgot password?</p>
          </div>
        </div>
      </div>
    </div>
  );
}
